import React, { createContext, useState, useEffect } from 'react';
import useFetch from '../Components/Fetch/useFetch';

export const ThemeDataContext = createContext();

// Tier codes hidden from the portal, per programLabel. Hidden tiers must be
// the highest ones — the meter is rescaled to end where the first hidden
// tier begins.
const HIDDEN_TIER_CODES = {
  '1677A350-B638-4323-AA59-4F198482D63B': ['Internal'],
};

const withHiddenTiers = (customization) => {
  const hiddenCodes = HIDDEN_TIER_CODES[localStorage.getItem('programLabel')];
  if (!hiddenCodes || !customization?.tiers) return customization;

  const visible = customization.tiers.filter(
    (tier) => !hiddenCodes.includes(tier.code)
  );
  if (visible.length === customization.tiers.length || visible.length === 0) {
    return customization;
  }

  const hidden = customization.tiers.filter((tier) =>
    hiddenCodes.includes(tier.code)
  );
  // The bar now ends where the lowest hidden tier begins.
  const maxPoints = Math.min(...hidden.map((tier) => tier.value));
  const visiblePercentage = visible.reduce(
    (sum, tier) => sum + (tier.barPercentage || 0),
    0
  );
  const scale = visiblePercentage > 0 ? 100 / visiblePercentage : 1;

  return {
    ...customization,
    maxPoints,
    tiers: visible.map((tier, index) => ({
      ...tier,
      barPercentage: (tier.barPercentage || 0) * scale,
      nextTier: index === visible.length - 1 ? 0 : tier.nextTier,
    })),
  };
};

const ThemeContext = (props) => {
  const { data: customization } = useFetch('/api/init/getLoyaltyInfo');
  const [theme, setTheme] = useState(customization);

  useEffect(() => {
    const next = withHiddenTiers(customization);
    if (JSON.stringify(theme) !== JSON.stringify(next)) {
      setTheme(next);
    }
  }, [customization, setTheme]);

  console.log('theme: ', theme);

  return (
    <ThemeDataContext.Provider value={theme}>
      {customization && props.children}
    </ThemeDataContext.Provider>
  );
};
export default ThemeContext;
